import React from 'react'
import cx from 'classnames'
import './styles.sass'

const FloatingBadge = ({ children, className, animated, ...props }) => (
  <div className={cx('floating-badge', className, animated && 'floating-badge--animated')} {...props}>
    {children}
  </div>
)

export default FloatingBadge



// WEBPACK FOOTER //
// ./src/client/components/FloatingBadge/index.jsx